export default __webpack_public_path__ + "static/media/search_not_found_gray.fe476b7c.svg";